import React, { useEffect, useState } from 'react';
import { notification, Modal, Button } from 'antd';
import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import Table from 'components/Table';
import { useSelector, useDispatch } from 'react-redux';
import { setStore, setUserStores } from 'app/features/userSlice';
import './assets/style.css';
import { useQuery } from 'react-query';
import { Breadcrumbs } from '../../components/Atom/breadcumbs';
import { PageHeader } from '../../components/Atom/PageHeader';
import { ResetButton } from '../../components/Atom/Button';
import RoutingRuleForm from './assets/ruleForm';
import SearchField from '../../components/Atom/SearchField/index';
import { useNavigate } from 'react-router-dom';
import { convertToStoreTimezone, checkUserPermissions } from 'utils/services';
import { USER_ROLES, TIMEZONES } from 'utils/constant';
import StatusTag from '../../components/Atom/StatusTag';
import { deleteRule, getRules } from 'api/routingRules';
export const PaymentRouting = () => {
  const store = useSelector((state) => state?.company?.store);
  const userStores = useSelector((state) => state?.company?.userStores);
  const dispatch = useDispatch();
  const [deleteRuleModal, setDeleteRuleModal] = useState(false);
  const navigate = useNavigate();
  const [isRuleDeleting, setIsRuleDeleting] = useState(false);
  const [ruleData, setRuleData] = useState(null);
  const [isAddRuleModalOpen, setIsAddRuleModalOpen] = useState(false);
  const syncRuleToRedux = (updatedRulesArray) => {
    const updatedStores = (userStores ?? [])?.map((s) => (s?._id?.toString() === store?._id?.toString() ? { ...s, payment_routing_rules: updatedRulesArray } : s));

    dispatch(setUserStores(updatedStores));

    const updatedCurrentStore = updatedStores?.find((s) => s?._id?.toString() === store?._id?.toString());
    if (updatedCurrentStore) {
      dispatch(setStore({ ...updatedCurrentStore, isSelected: store?.isSelected }));
    }
  };

  const handleDeleteRule = async (id) => {
    setIsRuleDeleting(true);
    const response = await deleteRule(id, store?._id);
    if (response) {
      notification.success({ message: 'RULE DELETED SUCCESSFULLY', placement: 'bottomRight' });
      setRuleData(null);
      handleRulesResponse(response);
      setIsRuleDeleting(false);
      setDeleteRuleModal(false);
    }
  };

  const columnsData = [
    {
      title: 'Rule Id',
      render: (value) => value?._id,
      key: 'rule_id',
    },
    {
      title: 'Name',
      render: (value) => value?.name,
      key: 'name',
    },
    {
      title: 'Active',
      render: (value) => (value?.enabled ? <CheckCircleTwoTone twoToneColor='#52C41A' style={{ fontSize: '18px' }} /> : <CloseCircleTwoTone twoToneColor='#F5222D' style={{ fontSize: '18px' }} />),
      key: 'active',
    },

    {
      title: 'Retry Strategy',
      render: (value) => <StatusTag tag={value?.payment_retry_strategy} />,
      key: 'payment_retry_strategy',
    },
    {
      title: 'Time',
      render: (value) => value?.updatedAt,
      key: 'updatedAt',
    },
    ...(checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN])
      ? [
          {
            title: 'Action',
            key: 'action',
            render: (ruleData, index) => {
              return (
                <div key={index} className='flex items-center gap-2'>
                  <>
                    <div
                      className='table-action-btn flex items-center justify-center'
                      onClick={() => {
                        setRuleData(ruleData);
                        setIsAddRuleModalOpen(true);
                      }}
                      style={{ cursor: 'pointer' }}>
                      Update
                    </div>
                    <div
                      type='primary'
                      className='table-action-btn'
                      onClick={() => {
                        setRuleData(ruleData);
                        setDeleteRuleModal(true);
                      }}
                      style={{ cursor: 'pointer' }}>
                      Delete
                    </div>
                  </>
                </div>
              );
            },
          },
        ]
      : []),
  ];
  const [search, setSearch] = useState('');
  const [searchQueryData, setSearchQueryData] = useState('');
  const fetchData = async () => {
    let params = { store_id: store?._id };
    if (searchQueryData) {
      params.search = searchQueryData;
    }
    const response = await getRules(params);
    const timezone = store?.settings?.timezone || TIMEZONES?.PKT;
    const result = await convertToStoreTimezone(response, timezone);
    return result;
  };
  const { data, refetch, isLoading, isFetching } = useQuery('routing_rules', () => fetchData(), {
    enabled: false,
    manual: true,
  });
  useEffect(() => {
    refetch();
  }, [store, searchQueryData]);
  const getSearch = async (e) => {
    if (e === '' || e == null) {
      notification?.error({ message: 'Please enter details for search', placement: 'bottomRight' });
    } else {
      setSearch(e);
      setSearchQueryData(e);
    }
  };

  const handleSearchReset = () => {
    setSearch('');
    setSearchQueryData('');
  };

  const handleRulesResponse = async (data) => {
    syncRuleToRedux(data);
    refetch();
  };
  const breadcrumbProps = {
    breadcrumbs: [
      {
        name: 'XPay',
        href: '/xpay',
      },
      {
        name: 'Payment Routing',
      },
    ],
  };
  const handleSearch = (e) => {
    setSearch(e?.target?.value?.trim());
  };
  const handleCloseRuleModal = () => {
    setIsAddRuleModalOpen(!isAddRuleModalOpen);
    setRuleData(null);
  };
  return (
    <div style={{ padding: '0px', width: '100%' }}>
      <div className='header-container'>
        <Breadcrumbs {...breadcrumbProps} />
        <div className='headerPage'>
          <div className='mb-0'>
            <PageHeader label='Payment Routing' button={<ResetButton onClick={isFetching ? '' : () => refetch()} loading={isFetching} />} />
          </div>
          {checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN]) && (
            <Button className='primaryBtn mr-4 rounded-lg create_button rule-btn' onClick={() => setIsAddRuleModalOpen(true)}>
              <span className='btn-text'>Add Rule</span>
            </Button>
          )}
        </div>
      </div>
      <div className='actionPanel'>
        <div className='headerContainer' style={{ width: '100%' }}>
          <div className='searchInput' style={{ width: '100%' }}>
            <SearchField
              handleOnChange={handleSearch}
              value={search}
              handlePressEnter={getSearch}
              onReset={handleSearchReset}
              placeholder={'Search'}
              dropdown={{ show: false }}
              enableSearchBtn={true}
            />
          </div>
        </div>
      </div>
      <br />
      <div className='overflow-x-auto custom-table'>
        <Table
          loading={isLoading}
          dataSource={data}
          columns={columnsData}
          onRow={(record) => {
            return {
              onClick: (event) => {
                const { className } = event?.target;
                if (!className?.includes('table-action-btn')) {
                  navigate(`/payment-routing/${record?._id}`, { state: { record } });
                }
              },
              className: 'custom-row-class',
            };
          }}
          pagingation={{ show: false }}
        />
      </div>
      <Modal
        title={<span style={{ fontWeight: '800', fontSize: '16px', color: '#262626' }}>{ruleData?.name ? ruleData?.name : 'New Rule'}</span>}
        className='routing-form-model'
        centered
        open={isAddRuleModalOpen}
        destroyOnClose
        footer={null}
        onCancel={handleCloseRuleModal}>
        <RoutingRuleForm ruleData={ruleData} handleClose={handleCloseRuleModal} updateRuleData={handleRulesResponse} />
      </Modal>
      <Modal
        // className='bin-modal'
        open={deleteRuleModal}
        width={400}
        centered
        onCancel={() => {
          setDeleteRuleModal(false);
        }}
        footer={false}
        okButtonProps={{ loading: isRuleDeleting }}
        destroyOnClose>
        <header className='font-semibold text-base mb-4'>Delete Rule</header>
        <div className='mb-8'>
          Are you sure you want to delete this Rule<span>{'?'}</span>
        </div>
        <div className='flex mt-4 popupConfirmBtn'>
          <Button
            onClick={() => {
              setDeleteRuleModal(false);
            }}
            block
            className='rounded-lg bg-plain'>
            Cancel
          </Button>
          <Button className='DeleteBtn ml-4 rounded-lg' block onClick={() => handleDeleteRule(ruleData?._id)} loading={isRuleDeleting}>
            Confirm
          </Button>
        </div>
      </Modal>
    </div>
  );
};
